import React, { useRef } from 'react';

export default function ABNField({ value, onChange, onLookup, status, businessName, businessNameOptions, onSelectBusinessName }) {
  const debounceRef = useRef(null);

  const handleInput = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 11);
    onChange({ target: { name: 'abn', value: digitsOnly } });

    clearTimeout(debounceRef.current);
    if (digitsOnly.length === 11) {
      debounceRef.current = setTimeout(() => onLookup(digitsOnly), 400);
    }
  };

  return (
    <>
      <div className="form-group">
        <label htmlFor="abn">
          ABN <span className="required-asterisk">*</span>
        </label>
        <input
          id="abn"
          name="abn"
          className="form-input"
          value={value}
          onChange={handleInput}
          required
          maxLength={11}
          inputMode="numeric"
          placeholder="11 digit ABN, no spaces"
        />
        <p className="field-hint">Enter your 11-digit ABN — we'll look up your registered business name(s)</p>
        {status?.loading && <p className="field-hint">Looking up ABN...</p>}
        {status?.message && (
          <p className={status.error ? 'msg-error' : 'msg-success'}>{status.message}</p>
        )}
      </div>

      {businessNameOptions?.length > 0 && (
        <div className="form-group">
          <label htmlFor="businessName">
            Business Name <span className="required-asterisk">*</span>
          </label>
          <select
            id="businessName"
            name="businessName"
            className="form-input"
            value={businessName}
            onChange={(e) => onSelectBusinessName(e.target.value)}
            required
          >
            <option value="" disabled>Select your registered business name</option>
            {businessNameOptions.map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
          <p className="field-hint">Select the business name matching your ABN registration</p>
        </div>
      )}
    </>
  );
}
